import React from 'react'
import { usePostRequest } from '../../hooks/request'
import { ANIMAL_RECORD_LIST } from '../../urls'
import { useMessage } from '../../hooks/message'
import { AnimalRecordForm } from './AnimalRecordForm'

export default function AnimalRecordCreate({ onSuccess, onCancel, animalId }) {
    const recordCreate = usePostRequest({ url: ANIMAL_RECORD_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const formData = new FormData()

        // Add record fields
        formData.append('animal', animalId)

        if (data.weight) {
            formData.append('weight', data.weight)
        }

        if (data.health_status) {
            formData.append('health_status', data.health_status)
        }

        if (data.notes) {
            formData.append('notes', data.notes)
        }

        if (data.record_date) {
            formData.append('record_date', data.record_date)
        }

        // Add multiple images
        if (data.newImages && data.newImages.length > 0) {
            data.newImages.forEach((image) => {
                formData.append('images', image)
            })
        }

        const { success } = await recordCreate.request({
            data: formData
        })

        if (success) {
            showMessage('Ёзув муваффақиятли қўшилди', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Янги ёзув қўшиш</b>
            </h1>

            <AnimalRecordForm
                loading={recordCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
        </div>
    )
}
